<template>
  <div class='cgu-dialog'>
  <div class="cgu">
  <CGUHeader />
  <CGUBody id="cgu-body" :content='htmlContent'/>
  <CGUFooter @clickBtn="acceptCGU" :enableBtn="acceptButtonIsClickable"/>
  </div>
  </div>
</template>

<script lang='ts'>
import { Component, Prop, Vue } from 'vue-property-decorator';
import CGUHeader from '@/components/CGU/CGUHeader.vue';
import CGUBody from '@/components/CGU/CGUBody.vue';
import CGUFooter from '@/components/CGU/CGUFooter.vue';

@Component({
  components: {
    CGUBody,
    CGUFooter,
    CGUHeader
  }
})

export default class CGUDialog extends Vue {
  @Prop()
  private htmlContent: any | undefined;
  @Prop()
  private isActive: boolean | undefined;

  private acceptButtonIsClickable: boolean = false;

  get dialogState(): boolean {
    return !!this.isActive;
  }

  private mounted() {
    const element = document.getElementById('cgu-body');
  element!.addEventListener('scroll', this.handleScroll);
  }
  private beforeDestroy() {
    const element = document.getElementById('cgu-body');
    if (element) {
      element.removeEventListener('scroll', this.handleScroll);
    }
  }
  private handleScroll(event: any) {
    // Any code to be executed when the window is scrolled
    const element = document.getElementById('cgu-body');
    const bodyBorder = 1;
    if (element && element.scrollHeight - element.scrollTop <= element.clientHeight + bodyBorder) {
      this.enableAccept();
    }
  }
  private enableAccept() {
    this.acceptButtonIsClickable = true;
  }
  private acceptCGU() {
    this.$store.dispatch('cgu/postAcceptCgu');
  }
}
</script>

<style lang='stylus'>
.cgu-dialog {
  position relative;
  top 3rem;
  left 50%;
  transform translateX(-50%)
  max-width 800px;
}
.cgu {
  background-color: white;
  border-radius 5px

}
#cgu-body {
  border 1px solid #88888888
}
#dialog-cgu {
  overflow-x: hidden !important;
}
</style>
